// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_nu-0";
export var discountCodeInput = "_nu-1";